import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RouterService } from 'src/app/services/router.service';

@Component({
  selector: 'app-prompt-generatro-layout',
  templateUrl: './prompt-generatro-layout.component.html',
  styleUrls: ['./prompt-generatro-layout.component.scss']
})
export class PromptGeneratroLayoutComponent {
  checkPromptImageStatus:boolean = false;
  constructor(private routerService: RouterService, private router: Router) {

  }



  goBack() {
    if (this.routerService.isExactPromptGeneratorPage()) {
      this.router.navigate(['/']);
    } else {
      this.router.navigate(['/prompt-generator']);
    }
  }

}
